import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { CheckoutPaymentExternalCardPage } from 'src/app/modals/checkout-payment-external-card/checkout-payment-external-card.page';

const routes: Routes = [
  {
    path: '',
    component: CheckoutPaymentExternalCardPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CheckoutPaymentExternalCardPage]
})
export class CheckoutPaymentExternalCardPageModule {}
